import script from "./MakeNominations.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeNominations.vue?vue&type=script&setup=true&lang=js"

import "./MakeNominations.vue?vue&type=style&index=0&id=4aba37fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aba37fc"]])

export default __exports__